"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _messages = _interopRequireDefault(require("./messages"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var requiredRuleTransformer = function requiredRuleTransformer(_ref) {
  var intl = _ref.intl;
  return {
    requiredValidator: function requiredValidator(inputValue) {
      return Boolean(inputValue) || intl.formatMessage(_messages["default"].requiredError);
    }
  };
};
var minLengthRuleTransformer = function minLengthRuleTransformer(_ref2) {
  var constraintValue = _ref2.constraintValue,
    intl = _ref2.intl;
  return {
    minLengthValidator: function minLengthValidator() {
      var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return String(inputValue).length >= constraintValue || intl.formatMessage(_messages["default"].minLengthError, {
        minValue: constraintValue
      });
    }
  };
};
var maxLengthRuleTransformer = function maxLengthRuleTransformer(_ref3) {
  var constraintValue = _ref3.constraintValue,
    intl = _ref3.intl;
  return {
    maxLengthValidator: function maxLengthValidator() {
      var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return String(inputValue).length <= constraintValue || intl.formatMessage(_messages["default"].maxLengthError, {
        maxValue: constraintValue
      });
    }
  };
};
var providedValidatorsStrategies = {
  required: requiredRuleTransformer,
  minLength: minLengthRuleTransformer,
  maxLength: maxLengthRuleTransformer
};
var getPresetValidators = function getPresetValidators(selectedValidations, intl) {
  return Object.entries(selectedValidations).reduce(function (providedValidators, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      propName = _ref5[0],
      constraintValue = _ref5[1];
    return _objectSpread(_objectSpread({}, providedValidators), constraintValue && providedValidatorsStrategies[propName]({
      constraintValue: constraintValue,
      intl: intl
    }));
  }, {});
};
var _default = exports["default"] = getPresetValidators;